import { Button } from 'components/button/Button'
import { ButtonProps } from 'components/button/types'
import {
  ThemedTextImageSection,
  ThemedTextImageSectionProps,
} from 'components/content/themedTextImageSection/ThemedTextImageSection'
import { Icon } from 'components/icon'
import { ContentfulImage } from 'components/Image'
import { Spacer } from 'components/spacer/Spacer'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { Namespaces } from 'utils/i18n/types'

interface Props {
  section: Extract<
    keyof Namespaces['dashlane']['dashlane'],
    'section_accounts' | 'section_passwords' | 'section_viruses' | 'section_vpn'
  >
  extraProps?: ThemedTextImageSectionProps
}

export const DashlaneLPSection = ({ section, extraProps }: Props) => {
  const { t } = useTranslation('dashlane')
  const images = useContentfulImages()
  const { isLogged } = useAuth()

  const ctaHref = isLogged ? '/me/dashboard?dashlane=true' : '/signup'

  return (
    <>
      <ThemedTextImageSection
        title={t(`dashlane.${section}.title`)}
        image={<ContentfulImage {...images[`dashlane_${section}`]} />}
        {...extraProps}
      >
        <Text>{t(`dashlane.${section}.description`)}</Text>
        <Button {...defaultButtonProps} href={ctaHref}>
          {t(`dashlane.${section}.cta`)}
        </Button>
      </ThemedTextImageSection>

      <Spacer size={[2, 6]} />
    </>
  )
}

const defaultButtonProps: ButtonProps = {
  type: 'button',
  variant: 'text',
  size: 'large',
  style: { alignSelf: 'start' },
  tone: 'dark',
  leftIcon: <Icon name="Dashlane" />,
}
